import CardHeader from 'components/CardHeader';
import KebabMenu from 'components/KebabMenu';
import ResponsiveDrawer from 'components/ResponsiveDrawer';
import TabPanel from 'components/TabPanel';
import TabPanels from 'components/TabPanels';
import ZubieDialog from 'components/ZubieDialog';

/**
 * Registers certain components as globals.
 *
 * @param {Object} payload
 * @param {Vue} Vue
 */
export default ({ Vue }) => {
  Vue.component('card-header', CardHeader);
  Vue.component('CardHeader', CardHeader);
  Vue.component('kebab-menu', KebabMenu);
  Vue.component('KebabMenu', KebabMenu);
  Vue.component('responsive-drawer', ResponsiveDrawer);
  Vue.component('ResponsiveDrawer', ResponsiveDrawer);
  Vue.component('tab-panel', TabPanel);
  Vue.component('TabPanel', TabPanel);
  Vue.component('tab-panels', TabPanels);
  Vue.component('TabPanels', TabPanels);
  Vue.component('zubie-dialog', ZubieDialog);
  Vue.component('ZubieDialog', ZubieDialog);
};
